let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kvPin")).then(() => parcelRequire('40GlL'));